module.exports = __webpack_public_path__ + "static/media/15.60f29b37.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/15.png
// module id = 517
// module chunks = 0